import { motion } from "framer-motion";
import { fadeInUp, staggerContainer, viewportConfig } from "@/lib/motion";
import { FlaskConical, Layers, BarChart3, Handshake } from "lucide-react";

const REASONS = [
  {
    num: "01",
    icon: FlaskConical,
    title: "R&D-Led by Design",
    desc: "Every product begins in the research lab. Our roadmap invests in advanced cell characterization, simulation-driven design, and prototype validation before anything reaches the production floor.",
  },
  {
    num: "02",
    icon: Layers,
    title: "Vertically Integrated",
    desc: "From cell sorting to pack-level assembly, BMS integration, and final testing — the entire value chain is being built to operate under one roof, reducing lead times and guaranteeing quality traceability.",
  },
  {
    num: "03",
    icon: BarChart3,
    title: "Scalable by Architecture",
    desc: "Manufacturing lines being architected for volume. Designed with modularity and automation at their core, they will scale from pilot batches to mass production without compromising process integrity.",
  },
  {
    num: "04",
    icon: Handshake,
    title: "Strategic Partnerships",
    desc: "Backed by the Sharda Group's industrial network and long-standing relationships with cell suppliers, technology partners, and institutional clients across India and beyond.",
  },
];

export default function WhyChooseSection() {
  return (
    <section data-testid="why-choose-section" className="relative py-10 md:py-14 lg:py-20 bg-[#040D1C] noise-overlay overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <motion.div initial="hidden" whileInView="visible" viewport={viewportConfig} variants={fadeInUp} className="mb-4">
          <span className="text-xs uppercase tracking-[0.3em] text-[#1E96FC]">
            // Why Sharda Energy Tech
          </span>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={viewportConfig} variants={fadeInUp} className="mb-10 md:mb-16 max-w-3xl">
          <h2 className="font-display text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold uppercase text-slate-100 leading-tight">
            Built different.{" "}
            <span className="text-[#1E96FC]">Engineered to last.</span>
          </h2>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={viewportConfig}
          variants={staggerContainer}
          className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6"
        >
          {REASONS.map((r, i) => (
            <motion.div
              key={i}
              variants={fadeInUp}
              className="glass-card rounded-sm p-6 md:p-8 group hover:bg-[#003771]/20 transition-all duration-300 relative"
            >
              {/* Number */}
              <span className="absolute top-6 right-6 text-4xl font-bold text-slate-400">
                {r.num}
              </span>
              <r.icon className="w-6 h-6 text-[#1E96FC] mb-4" />
              <h4 className="text-lg font-bold uppercase text-slate-200 mb-3 tracking-wide">
                {r.title}
              </h4>
              <p className="text-sm text-slate-400 leading-relaxed">
                {r.desc}
              </p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
